export default __webpack_public_path__ + "static/media/271.a2403c9b.gif";